import { createContext } from "react";

export const SignupContext = createContext<{
  signup: boolean;
  setSignup: React.Dispatch<{ payload: boolean; type: "updateSignup" }>;
}>({ signup: false, setSignup: () => { } });

export function signupReducer(
  state: any,
  action: { payload: boolean; type: "updateSignup" }
) {
  if (action.type === "updateSignup") {
    return action.payload
  } else {
    return state
  }
}
